<template>
  <v-switch
    inset
    v-model="localWelshEnabled"
    :label= "languageLabel"
    :false-icon="'mdi-translate'"
    :true-icon="'mdi-translate'"
    :class="{
      'language-switch-on': this.selectedLanguage === 'cy',
      'language-switch-off': this.selectedLanguage !== 'cy',
    }"
  >
  </v-switch>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { i18n } from "@/i18n/i18n";

export default {
  data: () => ({
    localWelshEnabled: false,
  }),
  computed: {
    ...mapState(["selectedLanguage"]),
    languageLabel() {
      return this.selectedLanguage === 'cy'
        ? 'Cymraeg'
        : 'English Language';
    },
  },
  methods: {
    ...mapActions(["updateLanguage"]),
  },
  watch: {
    localWelshEnabled() {
      this.updateLanguage(this.localWelshEnabled ? "cy" : "en");
    },
    selectedLanguage() {
      i18n.global.locale.value = this.selectedLanguage;
    },
  },
  created() {
    this.localWelshEnabled = this.selectedLanguage === "cy";
    i18n.global.locale.value = this.selectedLanguage;
  },
};
</script>

<style>
.language-switch-on,
.language-switch-off {
  --v-switch-track-height: 24px;
  --v-switch-thumb-size: 24px;
  --v-switch-track-width: 48px;
  transform: scale(1.25);
  transform-origin: left center;
  margin: 0;
  margin-left: 32px;
  width: 100%;
}
.language-switch-on .mdi-volume-high,
.language-switch-on .mdi-brightness-5,
.language-switch-on .mdi-translate {
  color: white;
  font-size: 14px;
  color: red;
}
.language-switch-off .mdi-volume-off,
.language-switch-off .mdi-brightness-3,
.language-switch-off .mdi-translate {
  color: white;
  font-size: 14px;
  background: black;
}
.language-switch-off .v-switch__thumb {
  background: black;
}

@media (max-width: 768px) {
  .language-switch-on,
  .language-switch-off {
    transform: scale(1.25);
  }
}
</style>
